"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundXToNDecimal = void 0;
function roundXToNDecimal(x, n) {
    const tenN = 10 ** n;
    return Math.round(x * tenN) / tenN;
}
exports.roundXToNDecimal = roundXToNDecimal;
//# sourceMappingURL=roundXToNDecimal.js.map